// Selectors for user slice

export const getUserLanguage = (state) => state.user.language;
export const getUserColorMode = (state) => state.user.colorMode;
export const getUserIsLoggedIn = (state) => state.user.isLoggedIn;
export const getUserProfile = (state) => state.user.profile;
export const getUserError = (state) => state.user.error;
export const getUserAcceptedCookies = (state) => state.user.acceptedCookies;
export const getUserRoles = (state) => state.user.roles;
